
export class EmployeesPaymentStatusDto {
    Id?: number;
    costCenterId: number;
    empId:number;
    projectId: number;
    subContractorId?: number;
    attenEligibility: boolean;
    assignedDate?: Date;
    unassignedDate?: Date;
    isActive?: boolean;
    createdAt? : Date | any;
    createdUser? : number;
    updatedAt? : Date | any;
    updatedUser? : number;
    versionFlag? : number;
}

export const EmployeesPaymentStatusDtoDefault : EmployeesPaymentStatusDto = {
    Id: 0,
    costCenterId: 1,
    empId:1,
    projectId: 1,
    subContractorId: 1,
    attenEligibility: true,
    // assignedDate: Date(),
    // unassignedDate: Date(),
    isActive: true,
    createdAt : new Date() ,
    createdUser : 0,
    updatedAt :new Date() ,
    updatedUser : 0,
    versionFlag : 0,

};

